import React from "react";
import BaseEdge, { roundTo } from "./BaseEdge";

// Arc-style edge (circular arc between two nodes)
export default function ArcEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  color,
}) {
  const from = nodeById[edge.from];
  const to = nodeById[edge.to];
  if (!from || !to) return null;

  const sx = roundTo(from.x + from.width / 2);
  const sy = roundTo(from.y + from.height / 2);

  const tx = roundTo(to.x + to.width / 2);
  const ty = roundTo(to.y + to.height / 2);

  const dx = tx - sx;
  const dy = ty - sy;

  // radius based on distance
  const r = Math.max(40, Math.hypot(dx, dy) / 2);

  // flags for SVG arc direction
  const largeArcFlag = r > 100 ? 1 : 0;
  const sweepFlag = dx * dy > 0 ? 1 : 0;

  const d = `M ${sx} ${sy} A ${r} ${r} 0 ${largeArcFlag} ${sweepFlag} ${tx} ${ty}`;

  const labelPos = {
    x: (sx + tx) / 2,
    y: (sy + ty) / 2 - 12,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
